/**
 * Navigation glyphs ported verbatim from the design handoff (primitives.jsx):
 * stroke 1.5, currentColor, 24×24 viewBox. Decorative — callers label the control.
 */
interface IconProps {
  size?: number;
  className?: string;
}

function stroke(size: number, className: string | undefined, d: string) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      <path d={d} />
    </svg>
  );
}

export function IconMenu({ size = 22, className }: IconProps) {
  return stroke(size, className, "M4 8h16M4 16h16");
}

export function IconClose({ size = 22, className }: IconProps) {
  return stroke(size, className, "M6 6l12 12M18 6L6 18");
}

export function IconArrowRight({ size = 18, className }: IconProps) {
  return stroke(size, className, "M5 12h14M13 6l6 6-6 6");
}

export function IconChevron({ size = 14, className }: IconProps) {
  return stroke(size, className, "M6 9l6 6 6-6");
}

export function IconBack({ size = 18, className }: IconProps) {
  return stroke(size, className, "M15 5l-7 7 7 7");
}

export function IconUser({ size = 18, className }: IconProps) {
  return stroke(
    size,
    className,
    "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 20c0-3.6 3.6-6 8-6s8 2.4 8 6",
  );
}

export function IconLogout({ size = 18, className }: IconProps) {
  return stroke(
    size,
    className,
    "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  );
}

export function IconBell({ size = 20, className }: IconProps) {
  return stroke(
    size,
    className,
    "M6 9a6 6 0 1 1 12 0c0 4 2 5 2 7H4c0-2 2-3 2-7ZM10 19a2 2 0 0 0 4 0",
  );
}

export function IconHome({ size = 22, className }: IconProps) {
  return stroke(size, className, "M4 11.2L12 4l8 7.2V20a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1v-8.8Z");
}

export function IconLibrary({ size = 22, className }: IconProps) {
  return stroke(size, className, "M5 4h3v16H5zM10.5 4h3v16h-3zM16 5.2l3 .8-4 14.4-3-.8z");
}

export function IconProfile({ size = 22, className }: IconProps) {
  return stroke(
    size,
    className,
    "M12 5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM5 20c1.6-3.2 4.2-4.8 7-4.8s5.4 1.6 7 4.8",
  );
}

/** T393 — the language row in the account menu. Same stroke as its siblings. */
export function IconGlobe({ size = 18, className }: IconProps) {
  return stroke(
    size,
    className,
    "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM3.5 9h17M3.5 15h17M12 3c2.2 2.4 3.3 5.4 3.3 9s-1.1 6.6-3.3 9c-2.2-2.4-3.3-5.4-3.3-9S9.8 5.4 12 3Z",
  );
}

/** T872 S1 — «Ayuda y soporte» row of the public account panel. */
export function IconHelp({ className, size = 18 }: { className?: string; size?: number }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .8-1 1.5v.2" />
      <circle cx="12" cy="17" r=".6" fill="currentColor" stroke="none" />
    </svg>
  );
}
